import Controller from "./tags.controller";
import template from "./tags.html";

const tags = {
  template,
  controller: Controller,
};

export default tags;



// WEBPACK FOOTER //
// ./src/pages/tags/tags.component.js